import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const DashboardErrorStatusContext = createContext({
  count: 0,
  onOpen: null,
  isOpen: false,
  setDashboardErrorStatus: () => {},
});

export const DashboardErrorStatusProvider = ({ children }) => {
  const [dashboardErrorStatus, setDashboardErrorStatusState] = useState({ count: 0, onOpen: null, isOpen: false });

  const setDashboardErrorStatus = useCallback((count, onOpen, isOpen = false) => {
    const normalizedCount = Number.isFinite(count) ? Math.max(0, Math.floor(count)) : 0;
    setDashboardErrorStatusState((currentStatus) => {
      const normalizedOnOpen = normalizedCount > 0 && typeof onOpen === 'function' ? onOpen : null;
      const normalizedIsOpen = normalizedCount > 0 && Boolean(isOpen);
      if (currentStatus.count === normalizedCount
        && currentStatus.onOpen === normalizedOnOpen
        && currentStatus.isOpen === normalizedIsOpen) {
        return currentStatus;
      }
      return { count: normalizedCount, onOpen: normalizedOnOpen, isOpen: normalizedIsOpen };
    });
  }, []);

  const value = useMemo(() => ({
    ...dashboardErrorStatus,
    setDashboardErrorStatus,
  }), [dashboardErrorStatus, setDashboardErrorStatus]);

  return (
    <DashboardErrorStatusContext.Provider value={value}>
      {children}
    </DashboardErrorStatusContext.Provider>
  );
};

export const useDashboardErrorStatus = () => useContext(DashboardErrorStatusContext);
